__turbopack_context__.v({
  "backdrop": "PaisModalSelector-module__In0KpG__backdrop",
  "clearSearchBtn": "PaisModalSelector-module__In0KpG__clearSearchBtn",
  "countryButton": "PaisModalSelector-module__In0KpG__countryButton",
  "countryButtonSelected": "PaisModalSelector-module__In0KpG__countryButtonSelected",
  "countryGrid": "PaisModalSelector-module__In0KpG__countryGrid",
  "countryListScroll": "PaisModalSelector-module__In0KpG__countryListScroll",
  "fadeIn": "PaisModalSelector-module__In0KpG__fadeIn",
  "flagBadge": "PaisModalSelector-module__In0KpG__flagBadge",
  "iconBadge": "PaisModalSelector-module__In0KpG__iconBadge",
  "modalCard": "PaisModalSelector-module__In0KpG__modalCard",
  "searchContainer": "PaisModalSelector-module__In0KpG__searchContainer",
  "searchIconWrapper": "PaisModalSelector-module__In0KpG__searchIconWrapper",
  "searchInput": "PaisModalSelector-module__In0KpG__searchInput",
  "zoomIn": "PaisModalSelector-module__In0KpG__zoomIn",
});
